import { CurrencyEnum, DateRangePicker, cents, centsToUnits } from '@systemeio/ui'
import MobileSettingsHeader from 'modules/funnels/funnel/components/mobile-settings-header'
import { FunnelStepSettingTabsEnum } from 'modules/funnels/funnel/enums/funnel-step-setting-tabs-enum'
import { FunnelStatisticsFilterInterface } from 'modules/funnels/funnel/types/funnel-statistics-interface'
import React from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import useUser from 'shared/hooks/use-user'
import { currencyFormat } from 'shared/utils/currency-format'

interface StatisticsTabTableLayoutProps {
  setFilter: React.Dispatch<React.SetStateAction<FunnelStatisticsFilterInterface>>
  filter: FunnelStatisticsFilterInterface
  currency: CurrencyEnum
  totalSales: number | null
  averageCartValue: number | null
  children: JSX.Element
}

function StatisticsTabTableLayout({
  filter,
  setFilter,
  currency,
  totalSales,
  averageCartValue,
  children,
}: StatisticsTabTableLayoutProps) {
  const { user, intlLocale } = useUser()
  const { t } = useLocoTranslation()

  return (
    <div className="mb-5 flex flex-col gap-8 px-[15px] lg:px-[15px]">
      <MobileSettingsHeader type={FunnelStepSettingTabsEnum.stats} />
      <div className="flex flex-col gap-4 lg:flex-row lg:flex-wrap lg:items-center lg:justify-between">
        <div className="flex flex-col gap-4 lg:flex-row lg:gap-20">
          <div className="flex flex-col gap-2">
            <div className="font-inter text-text-primary text-base lg:text-lg">
              {t('dashboard.funnel.statistics.gross')}
            </div>
            <div className="font-inter text-brand-primary text-xl font-bold lg:text-3xl">
              {currencyFormat(
                centsToUnits(cents(totalSales || 0)),
                currency,
                user?.dashboardLocale,
              )}
            </div>
          </div>
          <div className="flex flex-col gap-2">
            <div className="font-inter text-text-primary text-base lg:text-lg">
              {t('dashboard.funnel.statistics.average_cart_value')}
            </div>
            <div className="font-inter text-brand-primary text-xl font-bold lg:text-3xl">
              {currencyFormat(
                centsToUnits(cents(averageCartValue || 0)),
                currency,
                user?.dashboardLocale,
              )}
            </div>
          </div>
        </div>
        <DateRangePicker
          date={filter.date}
          onChange={date => {
            setFilter({ date: date })
          }}
          timezone={user?.timezone}
          createdAt={user?.createdAt}
          intlLocale={intlLocale}
        />
      </div>
      {children}
    </div>
  )
}

export default StatisticsTabTableLayout
